module.exports = __webpack_public_path__ + "media/images/close_icon_u73_mouseover-87d24492e969fdfd44593bc647d96e9d.svg";